import { Link, useParams } from 'react-router-dom';
import { Check } from 'lucide-react';
import { useOrderDetail } from '@/lib/queries';
import { ChefNav } from '@/components/ChefNav';
import { Button } from '@/components/ui/button';
import { formatQuantity } from '@/lib/utils';

// Order Confirmation — success screen shown immediately after placing an order.
export function OrderConfirmation() {
  const { id } = useParams<{ id: string }>();
  const { data } = useOrderDetail(id);
  const order = data?.data;

  return (
    <div className="min-h-screen bg-canvas">
      <ChefNav />
      <div className="mx-auto max-w-2xl px-4 py-16 text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-brand/15">
            <Check className="h-10 w-10 text-brand" />
          </div>
        </div>
        <h1 className="page-title page-title--xl mb-4">Order Placed</h1>
        <p className="mb-6 text-muted">
          Your order was submitted successfully and your items have been routed to their suppliers.
        </p>

        <div className="mb-8">
          <span className="eyebrow">Order Reference</span>
          <div className="font-mono text-2xl text-brand" data-testid="order-ref">
            {order?.orderNumber ?? id}
          </div>
        </div>

        {order && order.lines.length > 0 && (
          <div className="card mb-8 p-6 text-left">
            <h2 className="section-head mb-4">Order Summary</h2>
            <ul className="space-y-2 text-sm">
              {order.lines.map((l) => (
                <li key={l.id} className="flex justify-between">
                  <span className="text-ink">{l.productName}</span>
                  <span className="text-muted">
                    {formatQuantity(l.quantity)} {l.unitOfMeasure}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Link to={`/app/orders/${id}`}>
            <Button className="w-full sm:w-auto">View Order Details</Button>
          </Link>
          <Link to="/app">
            <Button variant="outline" className="w-full sm:w-auto">
              Place Another Order
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
